import React from 'react'
import { Flex } from '@components'
import { Form, Button, Modal } from 'antd'
import SiderMenu from '@pages/Assembly/siderMenu'
import Breadcrumb from '@pages/Assembly/Breadcrumb'
import TitleTop from '@pages/Assembly/titleTop'
import { message } from 'antd/lib/index'
import NHFetch from '../../../../utils/NHFetch'
import NHSelect from '@components/common/NHSelect'
import NHUpload from '@components/common/NHUpload'
import NHSignDraw from '@components/common/NHSignDraw'
import NextButton from '@pages/SelfHelp/common/nextIndex'
import { getLoginUser } from '@utils/NHCore'
import CommonTip from '../common'
import { mkbz } from '@pages/Assembly/siderMenu/menuObj'
import Hint from '@pages/SelfHelp/common/hint'
import { Scrollbars } from 'react-custom-scrollbars'
import html2canvas from 'html2canvas'
import css from './index.css'

const FormItem = Form.Item
const basicUrl = 'api/zhxg-yxwz'
const { confirm } = Modal

const formItemLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 10 }
}

@Form.create()
export default class SignCheckInPledge extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      xsid: getLoginUser().userId,
      zzbdhjid: this.getUrlParams('pkid'),
      mkbz: 'GD041_10',
      hjmc: '住宿承诺书签署',
      editable: false,
      nextUrl: '',
      search: '',
      operable: true,
      nonOperationalData: {},
      modalVisible: false,
      uploadModalVisible: false,
      signature: '',
      rzsqUndertakingHtml: '',
      xwzsUndertakingHtml: '',
      xssfytj: '',
      formData: {},
      isRender: false,
      templateList: [],
      uploadFjid: '',
    }
  }

  componentDidMount() {
    this.queryQztjAndYlhj()
    this.getRzsqCnsPz()
  }

  queryQztjAndYlhj = () => {
    const { zzbdhjid } = this.state
    let xsid = getLoginUser() ? getLoginUser().userId : ''
    if (!xsid) {
      this.setState({
        nonOperationalData: { nologin: true },
        operable: false
      })
      return
    }
    NHFetch('/zzbd/queryQztjAndYlhj', 'GET', { xsid: xsid, zzbdhjid }).then(res => {
      if (res && res.data) {
        let kfsj = res.data['kfsj']
        let ylhj = res.data['ylhj']
        let qzhj = res.data['qzhj']
        let nohj = res.data['nohj']
        this.setState({ nonOperationalData: res.data })
        if (kfsj && kfsj['YXSJ'] != '1') {
          this.setState({ operable: false })
        }
        if (ylhj && ylhj.length > 0) {
          this.setState({ operable: false })
        }
        if (qzhj && qzhj.length > 0) {
          this.setState({ operable: false })
        }
        if (nohj) {
          this.setState({ operable: false })
        }
      }
    })
  }

  setMenuList = menuList => {
    let nextCount = 0
    let bz = this.state.mkbz
    menuList.map((elem, index) => {
      if (elem.HJDM == bz) {
        let hjmc = elem.HJMC
        this.setState({ hjmc: hjmc })
        nextCount = index + 1
        return
      }
    })
    let menu = menuList[nextCount]
    if (menu) {
      let hjdm = menu.HJDM
      if (hjdm.indexOf('GD') == 0) {
        let gdUrl = mkbz[hjdm]
        this.setState({
          nextUrl: gdUrl,
          search: 'pkid=' + menu.PKID
        })
      } else if (hjdm.indexOf('ZDY') == 0) {
        let zdyUrl = '/customLink'
        this.setState({
          nextUrl: zdyUrl,
          search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
        })
      }
    } else {
      this.setState({
        nextUrl: '',
        search: ''
      })
    }
  }

  getUrlParams = param => {
    return decodeURIComponent((new RegExp('[?|&]' + param + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
  }

  reloadMenu = () => {
    this.refs.siderMenu.reloadMenuList()
  }

  getUndertakingHtml = sfsq => {
    const { rzsqUndertakingHtml, xwzsUndertakingHtml } = this.state
    return sfsq === '1' ? rzsqUndertakingHtml : xwzsUndertakingHtml
  }

  getModalTitle = sfsq => {
    return sfsq === '1' ? '请阅读入住申请承诺书后签名' : '请上传校外住宿承诺书附件'
  }

  loadTemplateList = xwzsfjmb => {
    if (!xwzsfjmb) {
      this.setState({ templateList: [] })
      return
    }
    NHFetch(`api/zhxg-yxwz/dynamic/${xwzsfjmb}/getDetailed`, 'GET').then(res => {
      if (res && res.data && res.data.length > 0) {
        this.setState({
          templateList: res.data.map(item => ({
            uuid: item.uuid || item.fjid,
            name: item.name || item.fjmc || '附件模板'
          }))
        })
      } else {
        this.setState({ templateList: [] })
      }
    })
  }

  handleSubmit = e => {
    e.preventDefault()
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (err) {
        return
      }
      if (values.sfsq === '1') {
        const undertakingHtml = this.getUndertakingHtml(values.sfsq)
        if (!undertakingHtml) {
          message.warning('入住申请承诺书未配置')
          return
        }
        this.setState({ modalVisible: true, signature: '' })
      } else {
        this.setState({
          uploadModalVisible: true,
          uploadFjid: this.state.formData.xwzsfjid || ''
        })
      }
    })
  }

  submitUndertaking = () => {
    const { signature } = this.state
    const { getFieldValue } = this.props.form
    const sfsq = getFieldValue('sfsq')

    if (signature) {
      confirm({
        title: '确定提交?',
        onOk: () => {
          html2canvas(document.getElementById('signature'), { allowTaint: true, useCORS: true, scale: 1 }).then(canvas => {
            canvas.toBlob(blob => {
              this.saveXsRzsqCns({
                sfsq: sfsq,
                qm: blob
              })
            })
          })
        }
      })
    } else {
      message.warning('请签名')
    }
  }

  saveAttachment = fjzbid => {
    if (!fjzbid) {
      return Promise.resolve()
    }
    return NHFetch('api/zhxg-yxwz/dynamic/save', 'POST', [fjzbid])
  }

  submitUpload = () => {
    const { uploadFjid } = this.state
    const { getFieldValue } = this.props.form
    const sfsq = getFieldValue('sfsq')

    if (!uploadFjid) {
      message.warning('请上传附件')
      return
    }

    confirm({
      title: '确定提交?',
      onOk: () => {
        this.saveAttachment(uploadFjid).then(() => {
          this.saveXsRzsqCns({
            sfsq,
            xwzsfjid: uploadFjid
          })
        })
      }
    })
  }

  getRzsqCnsPz = () => {
    const { xsid } = this.state
    NHFetch(`${basicUrl}/zzbd/rzsqxx/getRzsqCnsPz?xsid=${xsid}`, 'GET').then(res => {
      if (res && res.code === 200) {
        let xssfytj = res.data?.xssfytj ?? '0'
        this.setState({
          rzsqUndertakingHtml: res.data?.nr ?? '',
          xwzsUndertakingHtml: res.data?.xwzsnr ?? '',
          xssfytj: xssfytj,
          editable: xssfytj === '0',
        })
        this.loadTemplateList(res.data?.xwzsfjmb)

        if (xssfytj === '1') {
          this.getXsRzsqCns()
        } else {
          this.setState({ isRender: true })
        }
      }
    })
  }

  saveXsRzsqCns = params => {
    const { xsid, zzbdhjid } = this.state
    const formData = new FormData()
    const token = window.sessionStorage.getItem('access_token')

    params.zzbdhjid = zzbdhjid
    params.czpt = '1'

    for (let key in params) {
      if (params[key] !== undefined && params[key] !== null) {
        formData.append(key, params[key])
      }
    }

    fetch(`${basicUrl}/zzbd/rzsqxx/saveXsRzsqCns`, {
      method: 'POST',
      headers: { token: token, loginUserId: xsid },
      body: formData
    })
      .then(async response => {
        const res = await response.json()
        if (res && res.code === 200) {
          if (res.data == '1') {
            message.success('信息保存成功！')
            this.getRzsqCnsPz()
            this.reloadMenu()
            this.setState({ editable: false, modalVisible: false, uploadModalVisible: false })
          } else {
            message.error('信息保存失败，请重试！')
          }
        } else {
          message.error(res?.message || '信息保存失败，请重试！')
        }
      })
      .catch(() => {
        message.error('信息保存失败，请重试！')
      })
  }

  getXsRzsqCns = () => {
    const { xsid } = this.state
    NHFetch(`${basicUrl}/zzbd/rzsqxx/getXsRzsqCns/${xsid}`, 'GET').then(res => {
      if (res && res.code === 200) {
        this.setState({ formData: res.data || {} }, () => {
          this.setState({ isRender: true })
        })
      }
    })
  }

  render() {
    const { getFieldDecorator, getFieldValue } = this.props.form
    const { editable, modalVisible, uploadModalVisible, signature, formData, isRender, templateList, uploadFjid } = this.state
    const date = new Date()
    const currentSfsq = editable ? getFieldValue('sfsq') : formData.sfsq
    const undertakingHtml = this.getUndertakingHtml(currentSfsq)
    const showAttachment = !editable && formData.sfsq === '0'

    return (
      <div>
        {this.state.operable ? (
          <Flex className="w1180 mt-20" align="start">
            <SiderMenu ref={'siderMenu'} setMenuList={this.setMenuList} title="自助报到" mkbz={this.state.mkbz} menuType="自助报到" />
            <Flex.Item className="page_con_r">
              <Breadcrumb noLine list={[{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]} />
              <div className="box">
                <Hint />
                <TitleTop title={this.state.hjmc} extra={false} />
                {isRender && (
                  <Form onSubmit={this.handleSubmit}>
                    <div className="p-sw">
                      <FormItem {...formItemLayout} label="是否申请入住">
                        {editable &&
                          getFieldDecorator('sfsq', {
                            initialValue: formData.sfsq,
                            rules: [
                              {
                                required: true,
                                message: '请选择是否申请入住'
                              }
                            ],
                          })(<NHSelect dataSource={[{
                            value: '1',
                            label: '是'
                          }, {
                            value: '0',
                            label: '否'
                          }]} />)}

                        {!editable && (formData.sfsq === '1' ? '是' : '否')}
                      </FormItem>

                      {showAttachment && (
                        <FormItem {...formItemLayout} label="校外住宿承诺书附件">
                          <NHUpload
                            serviceMark={'ly-sm-yxwz-svc'}
                            moduleName={'校外住宿承诺书附件'}
                            multiple={false}
                            fileCountLimit={1}
                            isEdit={false}
                            defaultEffective={true}
                            value={formData.xwzsfjid}
                          />
                        </FormItem>
                      )}

                      <div className="text-center mt-50">
                        {editable && (
                          <Button type="primary" htmlType="submit">
                            保存
                          </Button>
                        )}

                        {!editable && (
                          <Button type="primary" onClick={() => this.setState({ editable: true })}>
                            修改
                          </Button>
                        )}

                        <NextButton nextUrl={this.state.nextUrl} search={this.state.search} />
                      </div>
                    </div>
                  </Form>
                )}
              </div>
            </Flex.Item>
          </Flex>
        ) : (
          <CommonTip hjmc={'住宿承诺书签署'} key={'GD041_10'} mkbz="GD041_10" nonOperationalData={this.state.nonOperationalData} />
        )}

        <div style={{ width: '0px', height: '0px', overflow: 'hidden', position: 'relative' }}>
          <div id="signature" className={css.signature} style={{ position: 'absolute', top: 0, left: 0, zIndex: -1, width: 800, padding: '72px 68px' }}>
            <article dangerouslySetInnerHTML={{ __html: undertakingHtml }} />
            <div style={{ paddingLeft: 450 }}>
              <div>
                承诺人：
                <img src={signature} alt="签名" style={{ width: 150 }} />
              </div>
              <div>
                {date.getFullYear()} 年 {date.getMonth() + 1} 月 {date.getDate()} 日
              </div>
            </div>
          </div>
        </div>

        <Modal title={this.getModalTitle('1')} visible={modalVisible} destroyOnClose width="max-content" okText="提交" onOk={this.submitUndertaking} onCancel={() => this.setState({ modalVisible: false })}>
          <Scrollbars style={{ height: 380, width: 800 }}>
            <div className={css.signature} style={{ width: 800, padding: '72px 68px' }}>
              <article dangerouslySetInnerHTML={{ __html: undertakingHtml }} />
              <NHSignDraw label={'签名'} onChange={value => this.setState({ signature: value?.signImg || '' })} />
            </div>
          </Scrollbars>
        </Modal>

        <Modal
          title={this.getModalTitle('0')}
          visible={uploadModalVisible}
          destroyOnClose
          width={600}
          okText="提交"
          onOk={this.submitUpload}
          onCancel={() => this.setState({ uploadModalVisible: false })}
        >
          {templateList.length === 0 && (
            <div style={{ marginBottom: 12, color: '#999' }}>暂未配置附件模板，请联系管理员</div>
          )}
          <NHUpload
            serviceMark={'ly-sm-yxwz-svc'}
            moduleName={'校外住宿承诺书附件'}
            multiple={false}
            fileCountLimit={1}
            isEdit={true}
            defaultEffective={true}
            value={uploadFjid}
            onChange={value => this.setState({ uploadFjid: value })}
            templateList={templateList}
          />
        </Modal>
      </div>
    )
  }
}
